import React from "react";
import { map } from "lodash";

const thBase =
    "px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-700 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300";
const tdBase =
    "px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700 align-middle";

export function FragmentTableSubsidiary({
    subsidiarys,
    updateSubsidiary,
    onDeleteSubsidiary,
}) {
    return (
        <>
            {/* Desktop table */}
            <div className="hidden md:block overflow-x-auto max-h-[70vh] overflow-y-auto bg-white dark:bg-gray-900">
                <table className="min-w-full text-sm border-separate border-spacing-0">
                    <thead className="sticky top-0 z-10">
                        <tr>
                            <th className={thBase}>Nº</th>
                            <th className={thBase}>Serie</th>
                            <th className={thBase}>Nombre sede</th>
                            <th className={thBase}>Ruc</th>
                            <th className={thBase}>Razón Social</th>
                            <th className={thBase}>Celular</th>
                            <th className={thBase}>Dirección</th>
                            <th className={thBase}>Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        {map(subsidiarys, (subsidiary, index) => (
                            <tr
                                key={index}
                                className="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
                            >
                                <td
                                    className={`${tdBase} text-blue-600 dark:text-blue-400 font-medium text-center`}
                                >
                                    {subsidiary.id}
                                </td>
                                <td className={`${tdBase} text-center`}>
                                    {subsidiary.serial}
                                </td>
                                <td
                                    className={`${tdBase} font-semibold text-gray-800 dark:text-gray-200`}
                                >
                                    {subsidiary.name}
                                </td>
                                <td className={`${tdBase} text-center`}>
                                    {subsidiary.ruc}
                                </td>
                                <td className={`${tdBase}`}>
                                    {subsidiary.business}
                                </td>
                                <td className={`${tdBase} text-center`}>
                                    {subsidiary.phone}
                                </td>
                                <td className={`${tdBase}`}>
                                    {subsidiary.address}
                                </td>
                                <Actions
                                    subsidiary={subsidiary}
                                    updateSubsidiary={updateSubsidiary}
                                    onDeleteSubsidiary={onDeleteSubsidiary}
                                />
                            </tr>
                        ))}

                        {(!subsidiarys || subsidiarys.length === 0) && (
                            <tr>
                                <td
                                    colSpan={8}
                                    className="py-12 text-center text-sm text-gray-400 dark:text-gray-500"
                                >
                                    No hay sucursales para mostrar
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Mobile cards */}
            <div className="md:hidden divide-y divide-gray-100 dark:divide-gray-700">
                {map(subsidiarys, (subsidiary, index) => (
                    <div key={index} className="p-4">
                        <div className="flex items-start justify-between mb-3">
                            <div>
                                <p className="text-sm font-semibold text-gray-900 dark:text-white">
                                    <i className="fas fa-building mr-1 text-gray-400"></i>
                                    {subsidiary.name}
                                </p>
                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                    Serie: {subsidiary.serial}
                                </p>
                            </div>
                            <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300">
                                #{subsidiary.id}
                            </span>
                        </div>

                        <div className="grid grid-cols-1 gap-2 text-xs mb-3">
                            {subsidiary.ruc && (
                                <div className="flex justify-between items-center bg-gray-50 dark:bg-gray-700/50 rounded-lg px-3 py-1.5">
                                    <span className="text-gray-500 dark:text-gray-400">
                                        RUC
                                    </span>
                                    <span className="font-semibold text-gray-800 dark:text-gray-200">
                                        {subsidiary.ruc}
                                    </span>
                                </div>
                            )}
                            {subsidiary.business && (
                                <div className="flex justify-between items-center bg-gray-50 dark:bg-gray-700/50 rounded-lg px-3 py-1.5">
                                    <span className="text-gray-500 dark:text-gray-400">
                                        Razón Social
                                    </span>
                                    <span className="font-semibold text-gray-800 dark:text-gray-200 truncate max-w-[180px]">
                                        {subsidiary.business}
                                    </span>
                                </div>
                            )}
                            {subsidiary.phone && (
                                <div className="flex justify-between items-center bg-gray-50 dark:bg-gray-700/50 rounded-lg px-3 py-1.5">
                                    <span className="text-gray-500 dark:text-gray-400">
                                        Celular
                                    </span>
                                    <span className="font-semibold text-gray-800 dark:text-gray-200">
                                        {subsidiary.phone}
                                    </span>
                                </div>
                            )}
                            {subsidiary.address && (
                                <div className="flex justify-between items-center bg-gray-50 dark:bg-gray-700/50 rounded-lg px-3 py-1.5">
                                    <span className="text-gray-500 dark:text-gray-400">
                                        Dirección
                                    </span>
                                    <span className="font-semibold text-gray-800 dark:text-gray-200 truncate max-w-[180px]">
                                        {subsidiary.address}
                                    </span>
                                </div>
                            )}
                        </div>

                        <div className="flex items-center gap-2">
                            <button
                                type="button"
                                onClick={() => updateSubsidiary(subsidiary)}
                                className="flex-1 inline-flex items-center justify-center gap-1 rounded-lg border border-amber-300 dark:border-amber-700 text-amber-600 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20 text-sm font-medium px-3 py-2 transition-colors"
                            >
                                <i className="fas fa-pencil-alt"></i>
                                Editar
                            </button>
                            <button
                                type="button"
                                onClick={() => onDeleteSubsidiary(subsidiary)}
                                className="flex-1 inline-flex items-center justify-center gap-1 rounded-lg border border-red-300 dark:border-red-700 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 text-sm font-medium px-3 py-2 transition-colors"
                            >
                                <i className="fas fa-trash-alt"></i>
                                Eliminar
                            </button>
                        </div>
                    </div>
                ))}

                {(!subsidiarys || subsidiarys.length === 0) && (
                    <div className="py-12 text-center text-sm text-gray-400 dark:text-gray-500">
                        No hay sucursales para mostrar
                    </div>
                )}
            </div>
        </>
    );
}

function Actions({ subsidiary, updateSubsidiary, onDeleteSubsidiary }) {
    return (
        <td className={`${tdBase} text-center`}>
            <div className="flex items-center justify-center gap-1">
                <button
                    type="button"
                    onClick={() => updateSubsidiary(subsidiary)}
                    className="inline-flex items-center gap-1 rounded-md border border-amber-300 dark:border-amber-700 text-amber-600 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20 text-xs font-medium px-2 py-1 transition-colors"
                >
                    <i className="fa fa-pencil-alt"></i>
                </button>
                <button
                    type="button"
                    onClick={() => onDeleteSubsidiary(subsidiary)}
                    className="inline-flex items-center gap-1 rounded-md border border-red-300 dark:border-red-700 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 text-xs font-medium px-2 py-1 transition-colors"
                >
                    <i className="fas fa-trash-alt"></i>
                </button>
            </div>
        </td>
    );
}
